import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { Input } from '../Input/Input.js';
import { normalizePhone } from './normalizePhone.js';
export const PhoneInput = JSX(({ children, onChange, ...inputProps }) => {
    const handleChange = useCallback((v) => onChange && onChange(normalizePhone(v)), [onChange]);
    const handleBlur = useCallback((v) => {
        v === '+7 (' ? onChange && onChange('') : null;
    }, []);
    return (_jsx(Input, { ...inputProps, onChange: handleChange, onFocus: (ev) => handleChange(ev?.target?.value || ''), onBlur: (ev) => handleBlur(ev?.target?.value || ''), children: children }));
});
//# sourceMappingURL=PhoneInput.js.map